import React, { SetStateAction, Dispatch, useEffect, useState, Fragment } from "react";
import moment from "moment";

import { X } from "lucide-react";

import { AnalysisV1View } from "./V1";
import { AnalysisV2View } from "./V2";

import { useGetReportForCompleteData } from '../../../../hooks/analyses';

import { ISimulationReportResponse, ISimulationReportV1, ISimulationReportV2 } from "../../../../types/services.interface";

interface AnalysisViewProps {
    open: boolean;
    analysisId: number | null;
    setAnalysisViewData: Dispatch<SetStateAction<{ analysisId: number } | null>>;
};
export const AnalysisView = (props: AnalysisViewProps) => {
    const { open, analysisId, setAnalysisViewData } = props;

    const [reportResponse, setReportResponse] = useState<ISimulationReportResponse | null>(null);

    const { data: analysis, isLoading: isReportLoading } = useGetReportForCompleteData(analysisId);

    useEffect(() => {
        if (analysis?.reportResponse) {
            setReportResponse(analysis.reportResponse);
        };
    }, [analysis]);

    return (
        <div className={`complete_data__analysis ${open ? 'complete_data__analysis--open' : ''}`}>
            <div className='card card--md complete_data__analysis__content'>
                <div className='complete_data__analysis__header'>
                    <div>
                        <p className='text-lg text-bold mb-sm'>Analysis for:</p>
                        {analysis && (
                            <Fragment>
                                <p className='text-sm text-medium color--gray-600'>Scenario: <span className='color--gray-800'>{analysis.simulation_name}</span></p>
                                <p className='text-sm text-medium color--gray-600'>Attempt: <span className='color--gray-800'>{analysis.version}</span></p>
                                <p className='text-sm text-medium color--gray-600'>Created on: <span className='color--gray-800'>{moment(analysis.created_at).format('MMM DD, YYYY')}</span></p>
                                <p className='text-sm text-medium color--gray-600'>Conversation(s):</p>
                                <ul className="m-none">
                                    {analysis.conversations.map((conversation) => (
                                        <li key={conversation.id}>
                                            <p className="text-sm text-medium color--gray-600">
                                                {conversation.stage_person}&nbsp;
                                                <span className='color--gray-800'>({conversation.stage_title})</span>
                                                &nbsp;[Attempt {conversation.version}]
                                            </p>
                                        </li>
                                    ))}
                                </ul>
                            </Fragment>
                        )}
                    </div>
                    <button
                        className='complete_data__analysis__header__close_btn'
                        onClick={() => setAnalysisViewData(null)}
                    >
                        <X />
                    </button>
                </div>
                {isReportLoading && (
                    <div className='d-flex flex-column gap-sm justify-content-center align-items-center'>
                        <div className='list-loader' />
                        <p className='text-semibold'>Loading Analysis</p>
                    </div>
                )}
                {!isReportLoading && !reportResponse && (
                    <div className='d-flex flex-column gap-sm justify-content-center align-items-center'>
                        <p className='text-semibold'>No analysis yet!</p>
                    </div>
                )}
                {!isReportLoading && reportResponse && (
                    <div className="complete_data__analysis__view">
                        {reportResponse.version === 'v1' && <AnalysisV1View report={reportResponse.report as ISimulationReportV1} />}
                        {reportResponse.version === 'v2' && <AnalysisV2View report={reportResponse.report as ISimulationReportV2} />}
                    </div>
                )}
            </div>
        </div>
    );
};